import { Phone, Mail, MessageSquare, ArrowUpRight } from "lucide-react";

const CONTACT_ROWS = [
    {
        icon: Phone,
        label: "Mobile · Talk or Text",
        value: "480-694-5234",
        href: "tel:4806945234",
        testId: "contact-phone",
    },
    {
        icon: MessageSquare,
        label: "Text Message",
        value: "Same number — Tom replies fast",
        href: "sms:4806945234",
        testId: "contact-sms",
    },
    {
        icon: Mail,
        label: "Email",
        value: "tom@kitchensafe.net",
        href: "mailto:tom@kitchensafe.net",
        testId: "contact-email",
    },
];

function ContactRow({ icon: Icon, label, value, href, testId }) {
    return (
        <a
            href={href}
            data-testid={testId}
            className="flex items-center gap-5 p-5 md:p-6 group hover:bg-[#1a1a1e] transition-colors"
        >
            <div className="w-12 h-12 flex items-center justify-center border border-white/10 group-hover:border-[#E53935] group-hover:bg-[#E53935]/5 transition-all flex-shrink-0">
                <Icon className="w-4 h-4 text-white" strokeWidth={1.75} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-[#71717a] mb-1">
                    {label}
                </div>
                <div className="font-display font-bold text-base text-white truncate">{value}</div>
            </div>
            <ArrowUpRight className="w-4 h-4 text-[#71717a] group-hover:text-[#E53935] flex-shrink-0 transition-colors" />
        </a>
    );
}

function ContactHeadline() {
    return (
        <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-8">
                <span className="w-2 h-2 bg-[#E53935] rounded-full pulse-dot" />
                <span className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-[#E53935]">
                    / 07 — Secure Your Facility
                </span>
            </div>
            <h2 className="font-display font-extrabold text-5xl md:text-6xl lg:text-8xl leading-[0.9] tracking-[-0.04em]">
                Talk to Tom.
                <br />
                <span className="italic font-medium text-[#E53935]">Get a quote</span>
                <br />
                today.
            </h2>
            <p className="mt-8 text-base md:text-lg text-[#a1a1aa] max-w-xl leading-relaxed">
                Communication is one key to our success — a well-built, well-designed system
                doesn't hurt either. Free written proposal for your project, no pressure.
            </p>
        </div>
    );
}

function ContactPanel() {
    return (
        <div className="lg:col-span-5">
            <div className="border border-white/10 bg-[#141416] divide-y divide-white/10">
                {CONTACT_ROWS.map((r) => (
                    <ContactRow key={r.testId} {...r} />
                ))}
            </div>
            <a
                href="tel:4806945234"
                data-testid="contact-primary-cta"
                className="mt-4 w-full flex items-center justify-center gap-3 px-6 py-5 bg-[#E53935] hover:bg-[#F44336] text-white font-display font-bold text-lg tracking-tight transition-colors group"
            >
                Call now · 480-694-5234
                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
        </div>
    );
}

export default function Contact() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative py-20 md:py-24 border-t border-white/10 overflow-hidden"
        >
            <div className="absolute top-0 left-0 right-0 h-1 bg-[#E53935]" />
            <div className="absolute inset-0 bg-grid opacity-30" />

            <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-12 items-end">
                    <ContactHeadline />
                    <ContactPanel />
                </div>
            </div>
        </section>
    );
}
